import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ComponentizedEquipment} from '../shared/componentized-equipment.model';
import {EquipmentComponentizationService} from '../shared/equipment-componentization.service';

@Component({
  templateUrl: './equipment-componentization-form-dialog.component.html',
  styleUrls: ['./equipment-componentization-form-dialog.component.scss']
})
export class EquipmentComponentizationFormDialogComponent {

  equipment: ComponentizedEquipment[];
  parentEquipment: ComponentizedEquipment;
  childEquipment: ComponentizedEquipment[];
  submitMessage: string;
  submitError = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<EquipmentComponentizationFormDialogComponent>,
              private equipmentComponentizationService: EquipmentComponentizationService) {
    this.equipment = data.equipment;
    this.parentEquipment = this.equipment[0];
    this.childEquipment = this.equipment.slice(1);
  }

  componentizeEquipment() {
    const equipIds = this.equipment.map(equip => equip.equipId);
    this.equipmentComponentizationService.componentizeEquipment(equipIds)
      .subscribe(response => {
        if (response && response.error) {
          this.submitMessage = 'Failed to componentize the assets. Please try again or contact Tech Support for further assistance.';
          this.submitError = true;
        } else {
          this.submitMessage = 'Successfully componentize the assets!';
          this.submitError = false;
        }
      });
  }

  tryAgain() {
    this.submitMessage = null;
    this.submitError = false;
  }

  done() {
    this.dialogRef.close('Done');
  }

  close() {
    if (this.submitError) {
      this.dialogRef.close('Cancel');
    } else {
      this.done();
    }
  }
}
